import React from 'react';
import styled, { css } from 'styled-components';

type HotelCardRatingProps = {
  value: number;
};

const MetaTags = ({ count }: { count: number }) =>
  count ? (
    <>
      <meta itemProp="worstRating" content="1" />
      <meta itemProp="bestRating" content="10" />
      <meta itemProp="ratingCount" content={String(count)} />
    </>
  ) : null;

const HotelRatingSquare = ({ value }: HotelCardRatingProps) => {
  if (!value) return null;

  return (
    <>
      <MetaTags count={value} />
      <Rating
        itemProp="aggregateRating"
        itemScope
        itemType="https://schema.org/AggregateRating"
        value={value}
      >
        {value.toFixed(1)}
      </Rating>
    </>
  );
};

const getRatingStyle = (value: number) => {
  if (value >= 8.5) {
    return css`
      color: white;
      background: #00bc4b;
    `;
  }

  if (value >= 7) {
    return css`
      color: white;
      background: #6ac140;
    `;
  }

  return css`
    background: #888c93;
    color: white;
  `;
};

const Rating = styled.div<{ value: number }>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 48px;
  height: 32px;

  font-weight: bold;
  font-size: 20px;

  ${({ value }) => getRatingStyle(value)};

  border-radius: 5px;
`;

export default HotelRatingSquare;
